export const getMenuOptions = (options, isSuperUser) => {
    if (isSuperUser) return options;
    return options.filter((ele) => ele.value !== 'practice_chatbot');
};